var _path, _path2, _path3, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 380,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m282.65 102.07v254.58h-230.86v-332.66h152.71z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.793 15.982v0.003906h-0.00586v348.66h246.85v-0.0039h0.00586v-265.9l-82.83-82.76h-164.02zm15.996 16.004h138.52l0.00391 0.003906v76.336h76.336v240.32h-214.86v-316.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m43.785 137.24-27.748 27.748v126h302.35v-126l-27.744-27.748v27.748h-246.86v-27.748z",
    fill: "#ed1c24"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 272,
    fill: "#ffffff",
    fontFamily: "'DejaVu Sans'",
    fontSize: "105px",
    fontWeight: "bold"
  }, "PDF")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfLogo);
export default __webpack_public_path__ + "static/media/pdf_logo.4c585031734567c5c61a9e724186a115.svg";
export { ForwardRef as ReactComponent };